import { render } from "./QuizPageThree.vue?vue&type=template&id=e7b82544&scoped=true"
import script from "./QuizPageThree.vue?vue&type=script&lang=js"
export * from "./QuizPageThree.vue?vue&type=script&lang=js"

import "./QuizPageThree.vue?vue&type=style&index=0&id=e7b82544&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7b82544"]])

export default __exports__